exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{text-indent:-99999px;margin:0px;position:fixed;width:100%;height:80%;top:20%;z-index:1111 !important}.spinner{border:8px solid #ebeced;border-radius:50%;border-top:8px solid #265390;width:55px;height:55px;position:absolute;margin:auto;top:0;bottom:0;left:0;right:0;animation:spin 1s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.scss
// module id = 1105
// module chunks = 0 1 2 3 4 5 6 7